export enum CustomFieldType {
  NUMERICALL = "NUMERICAL",
  TEXT = "TEXT"
}
